export default {
  get_all: { method: "get", url: "api/concedentes-contatos" },
  show: { method: "get", url: "api/concedentes-contatos{/id}" },
  store: { method: "post", url: "api/concedentes-contatos" },
  update: { method: "put", url: "api/concedentes-contatos{/id}" },
  delete: { method: "delete", url: "api/concedentes-contatos{/id}" },
};
